<script
  setup
  lang="ts"
  generic="
    ListingFilter extends {
      id: string;
      code: string;
      label: string;
      name: string;
    }
  ">
import type {
  AggregationFilterEntity,
  EntitiesAggregation,
  MaxAggregation,
  PriceAggregation,
} from "@shopware-pwa/types";
import { onClickOutside } from "@vueuse/core";
import { computed, ref } from "vue";

const props = defineProps<{
  filter: ListingFilter;
  selectedFilters: {
    [key: string]:
      | EntitiesAggregation<AggregationFilterEntity>
      | PriceAggregation
      | MaxAggregation
      | number;
  };
}>();

const emits = defineEmits<{
  (e: "select-value", value: { code: string; value: unknown }): void;
}>();
const currentFilterData = computed(
  () => !!props.selectedFilters[props.filter?.code],
);
const onChangeOption = (): void => {
  emits("select-value", {
    code: props.filter?.code,
    value: !currentFilterData.value,
  });
};

const isFilterVisible = ref<boolean>(false);
const toggle = () => {
  isFilterVisible.value = !isFilterVisible.value;
};

const dropdownElement = ref(null);
onClickOutside(dropdownElement, () => (isFilterVisible.value = false));
</script>

<template>
  <div class="filter-wrap">
    <h3 class="filter-head">
      <button
          type="button"
          @click="toggle"
      >
        <span>{{ filter.label }}</span>
        <span class="ml-6 flex items-center">
          <i :class="[
              !isFilterVisible
                ? 'i-carbon-chevron-down'
                : 'i-carbon-chevron-up',
            ]"
          />
        </span>
      </button>
    </h3>
    <transition name="fade" mode="out-in">
      <div v-show="isFilterVisible" id="filter-section-0" class="filter-body" ref="dropdownElement">
        <div class="flex form__checks">
          <div class="checkbox checkbox--alt form__checkbox" @click="onChangeOption()">
            <input
                :id="`filter-mobile-${filter.id || filter.code}`"
                :checked="currentFilterData"
                :name="filter.name"
                :value="filter.name"
                type="checkbox"
                class="form-check-input"
            />

            <label
                :for="`filter-mobile-${filter.id || filter.code}`"
                class="ml-3 text-gray-600"
            >
              {{ filter.label }}
            </label>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
